import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { FundsBuilder } from './views/FundsBuilder';
import { ObjectiveBuilder } from './views/ObjectiveBuilder';


export default /*#__PURE__*/_defineComponent({
  __name: 'FundsAcquisition',
  setup(__props) {

const route = useRoute();

const type = computed(() => {
  return route.params.type as string;
});

const isObjective = computed(() => {
  return type.value === 'objective';
});

const askForInvestorType = computed(() => {
  return Boolean(route.query?.qualifiedInvestor);
});

return { __sfc: true,route, type, isObjective, askForInvestorType, FundsBuilder, ObjectiveBuilder }
}

})